import { render, staticRenderFns } from "./DeleteLearningHub.vue?vue&type=template&id=776d0b7e"
import script from "./DeleteLearningHub.vue?vue&type=script&lang=js"
export * from "./DeleteLearningHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports